import objectsCorporate from './../recorders/objects';

export const trackCorpToReg = (subFunnelName) => {
  return objectsCorporate.corporate.corpToReg(subFunnelName);
};

export const trackRegToCorp = (subFunnelName) => {
  return objectsCorporate.corporate.regToCorp(subFunnelName);
};